import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ToastrModule } from 'ngx-toastr';
import { StoresModule } from './stores/stores.module';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { TranslateModule } from './core/translate/translate.module';
import { MatIconModule } from '@angular/material/icon';
import { AppInjector } from './core/app-injector';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { NgxTrimDirectiveModule } from './shared/directives/ngx-trim.directive';
import { SimpleModalModule } from './shared/components/simple-modal/simple-modal.module';
import { NotificationPopupModule } from './shared/components/notification-popup/notification-popup.module';
import { MaterialModule } from './shared/modules/material/material.module';
import { initializeApp } from 'firebase/app';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { SocketsManagerModule } from './sockets-manager/sockets-manager.module';
import { OfflineBarModule } from './shared/components/offline-bar/offline-bar.module';
import { UpdateBarModule } from './shared/components/update-bar/update-bar.module';

if (environment.firebaseConfig) {
  initializeApp(environment.firebaseConfig);
}

@NgModule({
  declarations: [
    AppComponent,
  ],
	imports: [
		CommonModule,
		StoresModule,
		LoadingBarModule,
		AppRoutingModule,
		HttpClientModule,
		HttpClientJsonpModule,
		CoreModule,
		BrowserModule,
		BrowserAnimationsModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		TranslateModule,
		MatIconModule,
		NgxTrimDirectiveModule,
		SimpleModalModule,
		NotificationPopupModule,
		MaterialModule,
		ToastrModule.forRoot(),
		MatProgressBarModule,
		MatDatepickerModule,
		MatNativeDateModule,
		SocketsManagerModule,
		OfflineBarModule,
		MatNativeDateModule,
		UpdateBarModule
	],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER
  ],
  bootstrap: [ AppComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.setInjector(injector);
  }
}
